export const env = {
  API_ENDPOINT:
    "http://servicioselectronicos.rpi.gob.ec/rpi_servicios/public/api/RpiCertificados",
};
